export const ESTATE_PEOPLE_ATTRIBUTES = {
  IS_CUSTOMER: 'isCustomer',
  IS_POINT_OF_CONTACT: 'isPointOfContact',
  PERSONAL_REPRESENTATIVE_TYPE: 'personalRepresentativeType',
  PERSONAL_REPRESENTATIVE_ROLE: 'personalRepresentativeRole',
  ADDRESS: 'address',
  DATE_OF_BIRTH: 'dateOfBirth',
  NOTES: 'notes',
  TITLE: 'title',
  FIRST_NAMES: 'firstNames',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  PHONE_NUMBER: 'phoneNumber',
  ORIGINAL_CONTACT_ID: 'originalContactId',
} as const

export const PRIMARY_EXECUTOR_TOOLTIP_TEXT =
  'We need a Primary Executor for every case. Legally, they will be our customer (even if someone else helps through the process).'

export const PRIMARY_ADMINISTRATOR_TOOLTIP_TEXT =
  'We need a Primary Administrator for every case. Legally, they will be our customer (even if someone else helps through the process).'
